const defaultColor = "palegreen";
function SideList({
    alignRight=false,
    reducedHeight=false,
    title,
    secondaryText,
    extraBefore,
    listItems,
    extraAfter,
    color = defaultColor,
    id
}){
    const reversedClass = alignRight ? "flex-md-row-reverse" : "";
    const height = reducedHeight ? "my-0 my-md-0 ms-4" : "mx-lg-auto my-3 my-md-5";
    return (
        <div className="container my-4 container-wide box-shadow" id={id}>
                <div className={`row ${reversedClass} justify-content-center align-items-center`}>
                <div className="col-10 col-lg-auto mt-5">
                    <h1 className={`display-6 fw-bold text-body-emphasis lh-1 mb-3 quint ${color}`}>
                        {title}
                    </h1>
                    {(secondaryText && secondaryText.trim() !== '') &&
                        <h3 className={`fw-bold text-body-emphasis lh-1 mb-3 quint ${color}`}>
                        {secondaryText}
                    </h3>}
                </div>
                <div className={`col-1 vr ${color}`} />
                <div className="col-10 col-lg-8">
                    {extraBefore && <p className="ms-3 mt-4 mb-1">{extraBefore}</p>}
                    <ul className={`d-block ${height} list-group list-group-flush`}>
                        {listItems.map((item, i) => <li key={i} className={`list-group-item border-${color}`}>{item}</li>)}
                    </ul>
                    {extraAfter && <p className="ms-3 mt-4">{extraAfter}</p>}
                </div>
            </div>
        </div>
    );
}

export default SideList;